import { createSlice } from "@reduxjs/toolkit";

const cropsSlice = createSlice({
  name: "crops",
  initialState: {
    data: null,
    isLoading: false,
    error: null,
  },
  reducers: {
    fetchCropsStart(state) {
      state.isLoading = true;
      state.error = null;
    },
    fetchCropsSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    fetchCropsFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const { fetchCropsStart, fetchCropsSuccess, fetchCropsFailure } =
  cropsSlice.actions;
export default cropsSlice.reducer;
